import { apiClient } from "../apiClient";

export const API_APP_BAIVIET_VIEW_PATH = "app-bai-viet-view"

export const appBaiVietViewApi = {
    SelectAll: (app_baiviet_id: number) => apiClient.get(API_APP_BAIVIET_VIEW_PATH + '/' + app_baiviet_id)
}